import { Title } from "@mantine/core";
import { useAiAssistantAdminContext } from "./ai-assistant-admin-context";
import { FailoverInsights } from "./failover-insights";
import { FailoverSwitch } from "./failover-switch";
import { ProviderCard } from "./provider-card";
import { ProviderModeCard } from "./provider-mode-card";

/** Sub menu "Penyedia AI": kesehatan failover, mode penyedia + sakelar failover, kredensial per fitur. */
export function PenyediaPage() {
	const { overview, disabled, applyProvider, applyProviderMode } =
		useAiAssistantAdminContext();
	return (
		<>
			<FailoverInsights />
			<ProviderModeCard
				status={overview.providerMode}
				disabled={disabled}
				cryptoConfigured={overview.cryptoConfigured}
				onSaved={applyProviderMode}
			>
				<FailoverSwitch
					mode={overview.providerMode.mode}
					disabled={disabled}
					cryptoConfigured={overview.cryptoConfigured}
					reloadWhen={overview.providers}
				/>
			</ProviderModeCard>
			<Title order={4}>Kredensial per fitur</Title>
			{overview.providers.map((slot) => (
				<ProviderCard
					key={slot.feature}
					slot={slot}
					disabled={disabled}
					cryptoConfigured={overview.cryptoConfigured}
					onSaved={applyProvider}
				/>
			))}
		</>
	);
}
